import indexToSafeArg from './allowlist.js';
const safeArgAllowlist = new Map(indexToSafeArg.map((v, i) => [v, i]));
const nonInterpolableAllowlist = new Set();
const safeArgsInfix = ' ; SafeArgs: ';
const MAX_INTERPOLATED_VALUES = 2;
export function safeString(strings, ...values) {
    if (!strings.raw) {
        throw new TypeError("Should only be used as a tagged template literal, e.g., safeString`my message ${'this value will be redacted in production'}`");
    }
    if (values.length > MAX_INTERPOLATED_VALUES) {
        throw new Error(`safeString only supports up to ${MAX_INTERPOLATED_VALUES} interpolated values`);
    }
    if (process.env.NODE_ENV === 'development') {
        return [strings[0], ...values.flatMap((arg, i) => [arg, strings[i + 1]])].join('');
    }
    const templatePart = strings.join('<redacted>');
    if (values.length === 0 &&
        templatePart.length > 1 &&
        `${Number(templatePart)}` !== templatePart) {
        if (!safeArgAllowlist.has(templatePart)) {
            safeArgAllowlist.set(templatePart, indexToSafeArg.length);
            indexToSafeArg.push(templatePart);
        }
    }
    else {
        nonInterpolableAllowlist.add(templatePart);
    }
    return (values.length > 0
        ? templatePart +
            safeArgsInfix +
            JSON.stringify(values.map((value) => safeArgAllowlist.get(String(value)) ?? -1))
        : templatePart);
}
export function parseString(value) {
    if (isSafe(value))
        return value;
    const [template, stringifiedValueIndexes] = value.split(safeArgsInfix);
    if (!isSafe(template))
        return '';
    let valueIndexes = [];
    try {
        valueIndexes = stringifiedValueIndexes ? JSON.parse(stringifiedValueIndexes) : [];
    }
    catch { }
    const mappedValues = valueIndexes.map((i) => Number.isSafeInteger(i) && i >= 0 && i < indexToSafeArg.length ? indexToSafeArg[i] : undefined);
    let i = 0;
    return template.replace(/<redacted>/gu, () => {
        return mappedValues[i++] ?? '<redacted>';
    });
}
export function isSafe(value) {
    if (process.env.NODE_ENV === 'development') {
        return true;
    }
    return safeArgAllowlist.has(value) || nonInterpolableAllowlist.has(value);
}
export function getAllowlist() {
    return [...indexToSafeArg, ...nonInterpolableAllowlist];
}
